module.exports = __webpack_public_path__ + "static/img/245.83d323fc.png";